import moment from "moment"
import React, { useEffect, useState } from "react"
import * as XLSX from "xlsx"

const LogFilter = ({
  status_options = [],
  emp_options = [],
  taskName_options = [],
  clientName_options = [],
  clientCode_options = [],
  logs = [],
  setLogs,
  all_logs,
  calculateTimeDifference = false,
  all_services = [],
  setVisible,
  type,
}) => {
  const [filters, setFilters] = useState({
    startMonth: "",
    startYear: "",
    endMonth: "",
    endYear: "",
    status: "",
    service: "",
    clientName: "",
    taskName: "",
    clientCode: "",
    employee: "",
    assistant: "",
    fromDate: "",
    toDate: "",
  })

  // Generate year options (last 5 years to next 2 years)
  const currentYear = new Date().getFullYear()
  const years = Array.from({ length: 8 }, (_, i) => currentYear - 5 + i)

  // Month options
  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ]

  const handleFilterChange = e => {
    const { name, value } = e.target
    setFilters({
      ...filters,
      [name]: value,
    })
  }

  const handleFilterSubmit = () => {
    const {
      startMonth,
      startYear,
      endMonth,
      endYear,
      status,
      employee,
      assistant,
      service,
      clientName,
      taskName,
      clientCode,
      fromDate,
      toDate,
    } = filters

    const filteredTasks = all_logs.filter(task => {
      let isValid = true

      // Convert dates to YYYY-MM format for month comparison
      const taskPeriodEnd = moment(task?.periodEnd).format("YYYY-MM")
      const taskDueDate = moment(task?.dueDate).format("YYYY-MM")

      // Filter by Period End Month
      if (startYear && startMonth) {
        const selectedPeriodEnd = `${startYear}-${startMonth}`
        if (selectedPeriodEnd !== taskPeriodEnd) {
          isValid = false
        }
      }

      // Filter by Due Date Month
      if (endYear && endMonth) {
        const selectedDueDate = `${endYear}-${endMonth}`
        if (selectedDueDate !== taskDueDate) {
          isValid = false
        }
      }

      // console.log("service", service,task.serviceName)

      // Filter by Service
      if (all_services.length) {
        if (service && task.serviceName.id != parseInt(service)) {
          isValid = false
        }
      }

      if (taskName_options.length) {
        if (taskName && task.title != String(taskName)) {
          isValid = false
        }
      }

      if (clientName_options.length) {
        if (clientName && task.client.clientName != String(clientName)) {
          isValid = false
        }
      }

      if (clientCode_options.length) {
        if (clientCode && task.client.clientCode != String(clientCode)) {
          isValid = false
        }
      }

      // Filter by Status
      if (status && task?.status?.id != parseInt(status)) {
        isValid = false
      }

      // Filter by Employee
      if (type === "timesheet") {
        if (employee && task?.employee?.id !== parseInt(employee))
          isValid = false
      } else if (type === "task") {
        if (employee && !checkEmpExist(task, employee, 1)) isValid = false
        if (assistant && !checkEmpExist(task, assistant, 2)) isValid = false
      }

      // Filter by Created At Date
      if (fromDate || toDate) {
        const taskCreatedAt = moment(task.createdAt).startOf("day")

        if (fromDate) {
          const from = moment(fromDate).startOf("day")
          if (taskCreatedAt.isBefore(from)) {
            isValid = false
          }
        }

        if (toDate) {
          const to = moment(toDate).endOf("day")
          if (taskCreatedAt.isAfter(to)) {
            isValid = false
          }
        }
      }

      return isValid
    })

    setLogs(filteredTasks)
    setVisible(false)
  }

  function checkEmpExist(currData, currEmp, type) {
    const empTypes =
      type == 1
        ? ["clientManager", "productionManager", "administrator", "assistant"]
        : ["assistant", "assistantTwo", "assistantThree", "assistantFour"]

    return empTypes.some(emp => currData[emp]?.id == currEmp)
  }

  console.log("logs", logs)

  const handleExportToExcel = () => {
    let exportData = []

    if (type === "timesheet") {
      exportData = logs.map(task => ({
        TaskID: task?.id,
        ["Employee Name"]: task?.employeeName || "--",
        ["Client Name"]: task?.clientName || "--",
        ["Client Code"]: task?.clientCode || "--",
        ["Start Time"]: moment(task.startTime, "HH:mm").format("hh:mm A"),
        ["End Time"]: moment(task.endTime, "HH:mm").format("hh:mm A"),
        ["Working Hour"]: task?.workingHour || "--",
        ["Total Hours"]: `${calculateTimeDifference(
          task.startTime,
          task.endTime
        )}`,
        ["Work Type"]: task?.workType?.workType,
        ["Correspondence Type"]: task?.correspondenceType || "--",
        Description: stripHtml(task?.workDescription),
        Status: task?.status?.statusName || "--",
        ["Attachment"]: task?.taskLogDocument
          ? `${process.env.REACT_APP_IMAGE_PATH}/${task?.taskLogDocument}`
          : "--",
        ["Created Date"]: moment(task.createdAt).format("DD-MM-YYYY | hh:mm A"),
      }))
    } else if (type === "task") {
      exportData = logs.map((task, index) => ({
        ["Sr No."]: index + 1,
        ["Client Code"]: task.client?.clientCode || "--",
        ["Client Name"]: task.clientName,
        ["Task Name"]: task.title,
        ["Period End"]: moment.utc(task.startDate).format("DD-MM-YYYY"),
        ["Due Date"]: moment.utc(task.dueDate).format("DD-MM-YYYY"),
        ["Assistant 1"]: task.assistant
          ? `${task.assistant?.name} ${task.assistant?.lastName}`
          : "--",
        ["Assistant 2"]: task.assistantTwo
          ? `${task.assistantTwo?.name} ${task.assistantTwo?.lastName}`
          : "--",
        ["Assistant 3"]: task.assistantThree
          ? `${task.assistantThree?.name} ${task.assistantThree?.lastName}`
          : "--",
        ["Assistant 4"]: task.assistantFour
          ? `${task.assistantFour?.name} ${task.assistantFour?.lastName}`
          : "--",
        ["Task Status"]: task.status?.statusName || "--",
        ["Total Time Spent"]: `${task?.totalTimeSpent} hrs` || "--",
      }))
    }

    const ws = XLSX.utils.json_to_sheet(exportData)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, "Filtered Tasks")

    XLSX.writeFile(
      wb,
      type === "task"
        ? `Tasks-(${moment().format("DD-MM-YYYY_hh-mm-ss")}).xlsx`
        : `Tasks_Logs-(${moment().format("DD-MM-YYYY_hh-mm-ss")}).xlsx`
    )
  }

  function stripHtml(htmlString) {
    const doc = new DOMParser().parseFromString(htmlString, "text/html")
    return doc.body.textContent || ""
  }

  const handleClearFilters = () => {
    setFilters({
      startMonth: "",
      startYear: "",
      endMonth: "",
      endYear: "",
      status: "",
      employee: "",
      assistant: "",
      service: "",
      clientName: "",
      taskName: "",
      clientCode: "",
      fromDate: "",
      toDate: "",
    })

    setLogs(all_logs)
    setVisible(false)
  }

  const assistantOptions = emp_options?.filter(e => e?.isAssistant)

  return (
    <div
      className={`row align-items-end mb-4 border-bottom border-primary pb-4`}
    >
      <div className="col-md-3">
        <label htmlFor="">Period End Month</label>
        <div className="row g-2">
          <div className="col-7">
            <select
              className="form-select"
              name="startMonth"
              value={filters.startMonth}
              onChange={handleFilterChange}
            >
              <option value="">Month</option>
              {months.map(m => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-5">
            <select
              className="form-select"
              name="startYear"
              value={filters.startYear}
              onChange={handleFilterChange}
            >
              <option value="">Year</option>
              {years.reverse().map(y => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="col-md-3">
        <label htmlFor="">Due Date Month</label>
        <div className="row g-2">
          <div className="col-7">
            <select
              className="form-select"
              name="endMonth"
              value={filters.endMonth}
              onChange={handleFilterChange}
            >
              <option value="">Month</option>
              {months.map(m => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-5">
            <select
              className="form-select"
              name="endYear"
              value={filters.endYear}
              onChange={handleFilterChange}
            >
              <option value="">Year</option>
              {years.reverse().map(y => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {type === "timesheet" ? (
        <>
          <div className="col-md-3 d-flex flex-column">
            <label htmlFor="fromDate">From Submitted Date</label>
            <input
              type="date"
              id="fromDate"
              name="fromDate"
              className="p-2"
              value={filters.fromDate}
              onChange={handleFilterChange}
              max={filters.toDate || new Date().toISOString().split("T")[0]}
            />
          </div>

          <div className="col-md-3 d-flex flex-column">
            <label htmlFor="toDate">To Submitted Date</label>
            <input
              type="date"
              id="toDate"
              name="toDate"
              className="p-2"
              value={filters.toDate}
              onChange={handleFilterChange}
              min={filters.fromDate}
            />
          </div>
        </>
      ) : null}

      {all_services.length > 0 ? (
        <div className="col-md-3">
          <label htmlFor="">Service</label>
          <select
            className="form-select"
            name="service"
            value={filters.service}
            onChange={handleFilterChange}
          >
            <option value="">All Services </option>
            {all_services
              ?.slice()
              .sort((a, b) => a?.serviceName?.localeCompare(b?.serviceName))
              .map(s => (
                <option key={s.id} value={s.id}>
                  {s?.serviceName}
                </option>
              ))}
          </select>
        </div>
      ) : null}

      {type === "task" && taskName_options.length > 0 ? (
        <div className="col-md-3">
          <label htmlFor="">Task Name</label>
          <select
            className="form-select"
            name="taskName"
            value={filters.taskName}
            onChange={handleFilterChange}
          >
            <option value="">All Tasks </option>
            {taskName_options
              ?.slice()
              .sort((a, b) => a.localeCompare(b))
              .map(task => (
                <option key={task} value={task}>
                  {task}
                </option>
              ))}
          </select>
        </div>
      ) : null}

      {type === "task" && clientName_options.length > 0 ? (
        <div className="col-md-3 mt-3">
          <label htmlFor="">Client Name</label>
          <select
            className="form-select"
            name="clientName"
            value={filters.clientName}
            onChange={handleFilterChange}
          >
            <option value="">All Clients </option>
            {clientName_options
              ?.slice()
              .sort((a, b) => a.localeCompare(b))
              .map(clientName => (
                <option key={clientName} value={clientName}>
                  {clientName}
                </option>
              ))}
          </select>
        </div>
      ) : null}

      {type === "task" && clientCode_options.length > 0 ? (
        <div className="col-md-3 mt-3">
          <label htmlFor="">Client Code</label>
          <select
            className="form-select"
            name="clientCode"
            value={filters.clientCode}
            onChange={handleFilterChange}
          >
            <option value="">All Clients</option>
            {clientCode_options
              ?.slice()
              .sort((a, b) => a.localeCompare(b))
              .map(clientCode => (
                <option key={clientCode} value={clientCode}>
                  {clientCode}
                </option>
              ))}
          </select>
        </div>
      ) : null}

      {status_options.length ? (
        <div className="col-md-3 mt-3">
          <label htmlFor="">Task Status</label>
          <select
            className="form-select"
            name="status"
            value={filters.status}
            onChange={handleFilterChange}
          >
            <option value="">All Status</option>
            {status_options
              ?.slice()
              .sort((a, b) => a?.statusName.localeCompare(b?.statusName))
              .map(s => (
                <option key={s?.id} value={s?.id}>
                  {s?.statusName}
                </option>
              ))}
          </select>
        </div>
      ) : null}

      {emp_options.length ? (
        <div className="col-md-3 mt-3">
          <label htmlFor="">Employee</label>
          <select
            className="form-select"
            name="employee"
            value={filters.employee}
            onChange={handleFilterChange}
          >
            <option value="">All Employees</option>
            {emp_options
              ?.slice()
              .sort((a, b) =>
                `${a.name} ${a.lastName}`.localeCompare(
                  `${b.name} ${b.lastName}`
                )
              )
              .map(s => (
                <option
                  key={s.id}
                  value={s.id}
                >{`${s.name} ${s.lastName}`}</option>
              ))}
          </select>
        </div>
      ) : null}

      {assistantOptions.length && type === "task" ? (
        <div className="col-md-3 mt-3">
          <label htmlFor="">Assistant</label>
          <select
            className="form-select"
            name="assistant"
            value={filters.assistant}
            onChange={handleFilterChange}
          >
            <option value="">All Assistant</option>
            {assistantOptions
              ?.slice()
              .sort((a, b) =>
                `${a.name} ${a.lastName}`.localeCompare(
                  `${b.name} ${b.lastName}`
                )
              )
              .map(s => (
                <option
                  key={s.id}
                  value={s.id}
                >{`${s.name} ${s.lastName}`}</option>
              ))}
          </select>
        </div>
      ) : null}

      <div className={`col-md-4 mt-4 `}>
        <button className="btn btn-primary " onClick={handleFilterSubmit}>
          <i className="fas fa-filter me-1"></i> Filter
        </button>
        <button className="btn btn-danger  ms-2" onClick={handleClearFilters}>
          <i className="fas fa-times me-1"></i> Clear
        </button>

        <button
          className="btn btn-success  ms-2"
          disabled={!logs.length}
          onClick={handleExportToExcel}
        >
          <i className="fas fa-file-export me-1"></i> Export
        </button>
      </div>
    </div>
  )
}

export default LogFilter
